import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { CSSTransition } from "react-transition-group";
import Button from "./Button";
import Header from "./Header";
import Icons from "./Icons";

function Modal(props: any) {

  useEffect(() => {
    if (props.active) {
      const width = document.body.clientWidth;
      document.body.style.overflow = "hidden";
      document.body.style.width = `${width}px`;
    } else {
      document.body.style.overflow = "visible";
      document.body.style.width = `auto`;
    }

    return () => {
      document.body.style.overflow = "visible";
      document.body.style.width = `auto`;
    };
  }, [props.active]);

  return ReactDOM.createPortal(
    <div className="loop">
      <CSSTransition
        in={props.active}
        unmountOnExit
        timeout={{ enter: 0, exit: 300 }}
      >
        <div className="loop-modal" onClick={props.toggleActive}>
          <div className="loop-modal-content" onClick={e => e.stopPropagation()}>
            <div className="loop-modal-header d-flex flex-row-reverse justify-content-between align-items-center">
              <Button variant="underline" className="me-2" onClick={props.toggleActive}>
                <Icons.Cancel />
              </Button>
              {props.title ? (
                <Header.H2>{props.title}</Header.H2>
              ) : null}
            </div>
            {props.children}
          </div>
        </div>
      </CSSTransition>
    </div>,
    document.body
  );
};

function ModalNew(props: any) {

  useEffect(() => {
    if (props.active) {
      const width = document.body.clientWidth;
      document.body.style.overflow = "hidden";
      document.body.style.width = `${width}px`;
    } else {
      document.body.style.overflow = "visible";
      document.body.style.width = `auto`;
    }

    return () => {
      document.body.style.overflow = "visible";
      document.body.style.width = `auto`;
    };
  }, [props.active]);

  return ReactDOM.createPortal(
    <div className="loop">
      <CSSTransition
        in={props.active}
        unmountOnExit
        timeout={{ enter: 0, exit: 300 }}
      >
        <div className={`loop-modal`} onClick={props.toggleActive}>
          <div className={`loop-modal-content ${props.className}`} onClick={e => e.stopPropagation()} style={{ ...props.style }}>
            <div className="loop-gift-modal-header">
              <Header.H2 className="loop-cp-gift-modal-header">{props.title}</Header.H2>
            </div>
            <div className="loop-gift-modal-content-body">
              {props.children}
            </div>
          </div>
        </div>
      </CSSTransition>
    </div>,
    document.body
  );
};

function Body(props: any) {
  return <div className="loop-modal-body">{props.children}</div>
}

function Footer(props: any) {
  return <div className="loop-modal-footer">{props.children}</div>
}

export default Object.assign(Modal, {
  Body: Body,
  Footer: Footer,
});

export const NewModal =  Object.assign(ModalNew, {
  Body: Body,
  Footer: Footer,
});
